import React, {Component} from 'react';
import '../assets-css/global.css'
import '../components/styles/form.css'
import { useTranslation, Trans } from 'react-i18next'

export default function Form(){
    const { t } = useTranslation();
        return (
            <React.Fragment>
                <div className="form-wrapper ">
                    <div className="form-info">
                        <h4>{t('formTitle1')}</h4>
                        <h3>{t('formTitle2')}</h3>
                        <hr/>
                        <p>
                        <Trans>{t('formAdress')}</Trans>
                        </p>
                    </div>
                    <div className="form-section">
                        <br/>
                        <h3>{t('formContact')}</h3>
                        <hr/>
                        <form className='form' method="POST" action="/Contacto" netlify netlify-honeypot="bot-field" name="form-name">
                        <label>
                            <input placeholder={t('formPlaceHolderName')} type="text" name='nombre'/>
                        </label>
                        <label>
                            <input placeholder={t('formPlaceHolderNumber')} type="text" name='numero'/>
                        </label>
                        <label>
                            <input placeholder={t('formPlaceHolderMail')} type="text" name='correo-electronico'/>
                        </label> <br/>
                        <label>
                            <textarea placeholder={t('formPlaceHolderMessage')} name="Mensaje:" id="" cols="40" rows="2"></textarea>
                        </label>
                        <br/>
                        <button className='buttonGreen' type='submit'>{t('formSendButton')}</button>
                        </form>
                    </div>
                </div>


            </React.Fragment>
        )
    }
